import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={46.438}
      height={38.676}
      viewBox="0 0 46.438 38.676"
      {...props}
    >
      <g transform="translate(-.33 -21.671)">
        <circle
          data-name="Ellipse 419"
          cx={18.309}
          cy={18.309}
          r={18.309}
          transform="translate(5.24 22.398)"
          fill="#f2c300"
        />
        <circle
          data-name="Ellipse 420"
          cx={14.474}
          cy={14.474}
          r={14.474}
          transform="translate(9.075 26.233)"
          fill="#f9d335"
        />
        <path
          data-name="Path 9054"
          d="M24.913 55.118q-.674.063-1.364.064a14.474 14.474 0 110-28.948q.69 0 1.364.064a14.475 14.475 0 000 28.82z"
          fill="#f9e27d"
        />
        <path
          data-name="Path 9055"
          d="M38.024 40.707a14.475 14.475 0 01-14.475 14.475q-.69 0-1.364-.064a14.474 14.474 0 000-28.82q.674-.063 1.364-.064a14.475 14.475 0 0114.475 14.473z"
          fill="#f2c300"
        />
        <path
          data-name="Path 9056"
          d="M42.002 59.619H5.094a.466.466 0 01-.466-.466v-7.406a.466.466 0 01.466-.466h36.908a.466.466 0 01.466.466v7.406a.466.466 0 01-.466.466z"
          fill="#44c7b6"
        />
        <path
          data-name="Path 9057"
          d="M1.058 52.908l.976 2.542-.976 2.542h3.567v-5.084z"
          fill="#4bdbc3"
        />
        <path
          data-name="Path 9058"
          d="M46.035 57.992l-.976-2.542.976-2.542h-3.571v5.084z"
          fill="#3bb2a0"
        />
        <path
          data-name="Path 9059"
          d="M7.823 59.619H5.095a.465.465 0 01-.466-.466v-7.407a.465.465 0 01.466-.466h2.728a.465.465 0 00-.466.466v7.407a.465.465 0 00.466.466z"
          fill="#4bdbc3"
        />
        <path
          data-name="Path 9060"
          d="M42.469 51.746v7.407a.465.465 0 01-.466.466h-2.728a.465.465 0 00.466-.466v-7.407a.465.465 0 00-.466-.466h2.73a.465.465 0 01.464.466z"
          fill="#3bb2a0"
        />
        <g data-name="Group 462" fill="#5f266d">
          <path
            data-name="Path 9061"
            d="M45.842 55.45l.876-2.281a.728.728 0 00-.679-.988H43.2v-.434a1.2 1.2 0 00-1.2-1.194h-2.159a19.036 19.036 0 10-32.585 0H5.094A1.2 1.2 0 003.9 51.747v.434H1.058a.728.728 0 00-.679.988l.876 2.281-.876 2.281a.728.728 0 00.679.988H3.9v.434a1.2 1.2 0 001.193 1.193H42a1.2 1.2 0 001.2-1.193v-.433h2.843a.728.728 0 00.679-.988zM3.9 57.264H2.117l.6-1.554a.728.728 0 000-.521l-.6-1.554H3.9zm19.649-34.138a17.6 17.6 0 0114.562 27.428h-2.987a15.2 15.2 0 10-23.15 0H8.986a17.6 17.6 0 0114.563-27.428zm9.584 27.427H13.964C5.169 42 11.229 26.961 23.549 26.961S41.927 42 33.133 50.553zm8.608 8.338H5.356v-6.883h36.385v6.883zm2.643-3.181l.6 1.554H43.2v-3.629h1.784l-.6 1.554a.728.728 0 000 .522z"
          />
          <path
            data-name="Path 9062"
            d="M6.754 57.674a.364.364 0 00.352.274h.572a.364.364 0 00.351-.268l.558-2.037.492 2.031a.364.364 0 00.354.278h.572a.364.364 0 00.35-.265l1.2-4.238a.364.364 0 00-.35-.463h-.56a.364.364 0 00-.352.272l-.532 2.032-.485-2.025a.364.364 0 00-.354-.279H8.35a.364.364 0 00-.352.271l-.551 2.08-.485-2.07a.364.364 0 00-.354-.281h-.579a.364.364 0 00-.352.453z"
          />
          <path
            data-name="Path 9063"
            d="M11.747 57.949h.566a.364.364 0 00.345-.25l.358-1.083h.979l.369 1.086a.364.364 0 00.344.247h.585a.364.364 0 00.344-.481l-1.446-4.238a.363.363 0 00-.344-.246h-.66a.364.364 0 00-.344.247l-1.44 4.238a.364.364 0 00.344.48zm1.757-2.873l.131.385h-.257z"
          />
          <path
            data-name="Path 9064"
            d="M16.607 57.948h.547a.364.364 0 00.364-.364v-1.473h.138c.259.01.4.038.508.54a4.543 4.543 0 00.323 1.115.364.364 0 00.315.181h.566a.364.364 0 00.32-.536 8.2 8.2 0 01-.293-1.072 1.832 1.832 0 00-.332-.743 1.456 1.456 0 00.517-1.132 1.406 1.406 0 00-.453-1.075 2.06 2.06 0 00-1.47-.44 6.042 6.042 0 00-1.123.1.364.364 0 00-.291.356v4.179a.364.364 0 00.364.364zm.911-3.844c.425-.022.788.026.788.424 0 .423-.419.441-.788.441z"
          />
          <path
            data-name="Path 9065"
            d="M20.684 57.948h.547a.364.364 0 00.364-.364v-1.473h.138c.26.01.4.038.508.54a4.569 4.569 0 00.323 1.114.363.363 0 00.315.182h.566a.364.364 0 00.32-.536 8.2 8.2 0 01-.292-1.072 1.836 1.836 0 00-.332-.743 1.457 1.457 0 00.517-1.132 1.406 1.406 0 00-.453-1.075 2.06 2.06 0 00-1.47-.44 6.034 6.034 0 00-1.123.1.364.364 0 00-.29.356v4.178a.364.364 0 00.362.365zm.911-3.844h.173c.615.007.615.292.615.429 0 .4-.414.441-.592.441h-.2z"
          />
          <path
            data-name="Path 9066"
            d="M24.467 57.949h.566a.364.364 0 00.345-.25l.358-1.083h.979l.369 1.086a.364.364 0 00.344.247h.585a.364.364 0 00.344-.481l-1.446-4.238a.364.364 0 00-.344-.246h-.66a.364.364 0 00-.344.247l-1.44 4.238a.364.364 0 00.344.48zm1.757-2.874l.131.385h-.262z"
          />
          <path
            data-name="Path 9067"
            d="M29.327 57.948h.516a.364.364 0 00.364-.364v-2.112c.076.123 0 .005 1.442 2.3a.363.363 0 00.308.171h.553a.364.364 0 00.364-.364v-4.236a.364.364 0 00-.364-.364h-.516a.364.364 0 00-.364.364v2.014l-1.4-2.208a.364.364 0 00-.307-.169h-.6a.364.364 0 00-.364.364v4.238a.364.364 0 00.368.366z"
          />
          <path
            data-name="Path 9068"
            d="M33.671 54.175h.925v3.409a.364.364 0 00.364.364h.553a.364.364 0 00.364-.364v-3.409h.932a.364.364 0 00.364-.364v-.468a.364.364 0 00-.364-.364h-3.138a.364.364 0 00-.364.364v.465a.364.364 0 00.364.367z"
          />
          <path
            data-name="Path 9069"
            d="M38.728 55.88v1.705a.364.364 0 00.364.364h.553a.364.364 0 00.364-.364v-1.706l1.372-2.348a.364.364 0 00-.314-.547h-.623a.363.363 0 00-.322.2c-.843 1.616-.536 1.028-.719 1.383-.079-.158-.106-.21-.7-1.38a.364.364 0 00-.324-.2h-.623a.364.364 0 00-.319.539z"
          />
          <path
            data-name="Path 9070"
            d="M18.178 37.568h-1.5v-3.817a.688.688 0 00-1.371 0v4.454a.631.631 0 00.63.63h2.242a.634.634 0 000-1.267z"
          />
          <path
            data-name="Path 9071"
            d="M20.351 33.752v4.454a.631.631 0 00.63.63h.111a.631.631 0 00.63-.63v-4.454a.688.688 0 00-1.371 0z"
          />
          <path
            data-name="Path 9072"
            d="M24.304 33.122a.631.631 0 00-.63.63v4.454a.631.631 0 00.63.63h.111a.631.631 0 00.63-.63v-1.627h1.257a.63.63 0 000-1.26h-1.257v-.931h1.412a.634.634 0 000-1.268z"
          />
          <path
            data-name="Path 9073"
            d="M32.361 38.198a.631.631 0 00-.63-.63h-1.53v-1.07h1.308a.63.63 0 000-1.26h-1.308v-.849h1.419a.634.634 0 000-1.268h-2.16a.631.631 0 00-.63.63v4.454a.631.631 0 00.63.63h2.271a.632.632 0 00.63-.637z"
          />
          <path
            data-name="Path 9074"
            d="M17.26 40.396h-3.159a.637.637 0 000 1.275h.884v3.809a.692.692 0 001.379 0v-3.809h.894a.637.637 0 000-1.275z"
          />
          <path
            data-name="Path 9075"
            d="M19.271 41.026v4.454a.688.688 0 001.371 0v-4.454a.688.688 0 00-1.371 0z"
          />
          <path
            data-name="Path 9076"
            d="M27.353 40.396h-.385a.632.632 0 00-.591.413l-.825 2.242c-.068.193-.13.373-.186.542a36.633 36.633 0 00-.178-.541l-.788-2.234a.631.631 0 00-.594-.421h-.384a.632.632 0 00-.629.586l-.311 4.454a.67.67 0 001.336.083l.118-1.89c0-.032 0-.064.006-.1l.72 2.12a.708.708 0 001.3.013l.817-2.243.011-.029c0 .062.007.123.01.182l.111 1.94a.679.679 0 001.352-.075l-.278-4.454a.632.632 0 00-.632-.588z"
          />
          <path
            data-name="Path 9077"
            d="M32.886 41.662a.634.634 0 000-1.268h-2.16a.631.631 0 00-.63.63v4.454a.631.631 0 00.63.63h2.272a.634.634 0 000-1.268h-1.53v-1.07h1.308a.63.63 0 000-1.26h-1.308v-.848h1.419z"
          />
          <path
            data-name="Path 9078"
            d="M29.53 30.064c-.145-.1-.3-.195-.457-.284a.727.727 0 00-.717 1.266c.381.216.468.347.764.347a.728.728 0 00.41-1.329z"
          />
          <path
            data-name="Path 9079"
            d="M26.149 30.245a.728.728 0 00.139-1.442 14.828 14.828 0 00-3.449-.246.728.728 0 00.1 1.452 15.384 15.384 0 013.21.236z"
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
